import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TableCell,
  TableRow,
} from '@material-ui/core';

import i18n from '../../i18n';

import {
  productTierOptions,
  productTierStyleMap
} from '../../constants/general';
import Dropdown from '../FormInput/Dropdown';

class EcommDataProductTierRow extends Component {
  render() {
    const {
      canEdit,
      getTabIndex,
      handleChange,
      locationData,
    } = this.props;
    return (
      <TableRow>
        <TableCell key="productTier" className="ecommTableLabel">
          <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
            {i18n.t('location:productTier').toUpperCase()}
          </Box>
        </TableCell>
        {Object.keys(locationData).map((element, index) => {
          return (
            <TableCell
              key={element}
              className={`studioDataRight ${
                productTierStyleMap[locationData[element].productTier]
              }`}
            >
              <Dropdown
                tabIndex={getTabIndex(index)}
                className="studioDataRight studioDataDropdown"
                value={locationData[element].productTier}
                name="productTier"
                disabled={!canEdit}
                options={productTierOptions}
                onChange={event => handleChange(event, element)}
              />
            </TableCell>
          );
        })}
      </TableRow>
    )
  }
}

EcommDataProductTierRow.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  getTabIndex: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  locationData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
}

export default EcommDataProductTierRow;
